const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/',
    tourPath: '/',
    locale: 'en',
    enableMock: true,
    demo: false,
}

export default appConfig
